import { getWfcServicesBuyButtonConfig } from '../utils/wfcEntitlements';

export const WFC_SERVICES_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.wfcServices.buyBox.bulletPoint1' },
        { title: 'productPage.wfcServices.buyBox.bulletPoint2' },
        { title: 'productPage.wfcServices.buyBox.bulletPoint3' }
      ],
      packageName: 'productPage.wfcServices.optionLabel.option1',
      productName: 'productPage.wfcServices.buyBox.productName1',
      interactService: {
        service: 'worry_free_service_basic',
        ctaType: 'internalCheckout'
      }
    },
    {
      bulletPoints: [
        { title: 'productPage.wfcServices.buyBox.bulletPoint1' },
        { title: 'productPage.wfcServices.buyBox.bulletPoint2' },
        { title: 'productPage.wfcServices.buyBox.bulletPoint3' },
        { title: 'productPage.wfcServices.buyBox.bulletPoint4' }
      ],
      packageColor: 'palette.background.green.main',
      packageName: 'productPage.wfcServices.optionLabel.option2',
      productName: 'productPage.wfcServices.buyBox.productName2',
      packageNote: 'productPage.wfcServices.optionLabel.option2Callout',
      interactService: {
        service: 'worry_free_service',
        ctaType: 'internalCheckout'
      }
    },
    {
      bulletPoints: [
        { title: 'productPage.wfcServices.buyBox.bulletPoint5' },
        { title: 'productPage.wfcServices.buyBox.bulletPoint6' },
        {
          title: 'productPage.wfcServices.buyBox.bulletPoint7',
          description: 'productPage.wfcServices.buyBox.bulletPoint7Tooltip'
        },
        {
          title: 'productPage.wfcServices.buyBox.bulletPoint8',
          description: 'productPage.wfcServices.buyBox.bulletPoint8Tooltip'
        }
      ],
      packageColor: 'palette.background.cyan.main',
      packageName: 'productPage.wfcServices.optionLabel.option3',
      productName: 'productPage.wfcServices.buyBox.productName3',
      packageNote: 'productPage.wfcServices.optionLabel.option3Callout',
      interactService: {
        service: 'worry_free_service_advanced',
        ctaType: 'internalCheckout'
      }
    }],
    headerPicture: {
      src: '/s2/raster/focused-woodworker-safety-goggles.png',
      alt: 'productPage.wfcServices.heroPicture.altText'
    },
    comparePackages: 'productPage.wfcServices.buyBox.comparePackages',
    plans: {
      title: 'productPage.wfcServices.compareModal.title',
      items: [
        {
          name: 'productPage.wfcServices.optionLabel.option1',
          service: 'worry_free_service_basic',
          features: [
            'productPage.wfcServices.comparePackages.features.option1',
            'productPage.wfcServices.comparePackages.features.option2',
            'productPage.wfcServices.comparePackages.features.option3',
            'productPage.wfcServices.comparePackages.features.option4',
            'productPage.wfcServices.comparePackages.features.option5',
            'productPage.wfcServices.comparePackages.features.option6'
          ],
          tag: null,
          icon: {
            src: '/s2/material-icons/shieldrounded.svg',
            color: 'text.tertiary',
            bgColor: 'grey'
          }

        },
        {
          name: 'productPage.wfcServices.optionLabel.option2',
          service: 'worry_free_service',
          features: [
            'productPage.wfcServices.comparePackages.features.option1',
            'productPage.wfcServices.comparePackages.features.option2',
            'productPage.wfcServices.comparePackages.features.option3',
            'productPage.wfcServices.comparePackages.features.option4',
            'productPage.wfcServices.comparePackages.features.option5',
            'productPage.wfcServices.comparePackages.features.option6',
            'productPage.wfcServices.comparePackages.features.option7'
          ],
          tag: {
            label: 'productPage.wfcServices.optionLabel.option2Callout',
            color: 'palette.secondary.light'
          },
          icon: {
            src: '/s2/material-icons/gppgoodrounded.svg',
            color: 'text.green',
            bgColor: 'green'
          }
        },
        {
          name: 'productPage.wfcServices.optionLabel.option3',
          service: 'worry_free_service_advanced',
          features: [
            'productPage.wfcServices.comparePackages.features.option1',
            'productPage.wfcServices.comparePackages.features.option2',
            'productPage.wfcServices.comparePackages.features.option3',
            'productPage.wfcServices.comparePackages.features.option4',
            'productPage.wfcServices.comparePackages.features.option5',
            'productPage.wfcServices.comparePackages.features.option6',
            'productPage.wfcServices.comparePackages.features.option8',
            'productPage.wfcServices.comparePackages.features.option9',
            'productPage.wfcServices.comparePackages.features.option10'
          ],
          tag: {
            label: 'productPage.wfcServices.optionLabel.option3Callout',
            color: 'palette.background.cyan.main'
          },
          icon: {
            src: '/s2/material-icons/workspacepremiumrounded.svg',
            color: 'text.blue',
            bgColor: 'cyan'
          }
        }
      ]
    },
    headline: 'productPage.wfcServices.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.wfcServices.page.subheader'
  },
  benefit: {
    title: 'productPage.wfcServices.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/receiptlongrounded.svg',
        title: 'productPage.wfcServices.valueProp.propTitle1',
        description: 'productPage.wfcServices.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/inventoryrounded.svg',
        title: 'productPage.wfcServices.valueProp.propTitle2',
        description: 'productPage.wfcServices.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/todayrounded.svg',
        title: 'productPage.wfcServices.valueProp.propTitle3',
        description: 'productPage.wfcServices.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/filedownloaddonerounded.svg',
    title: 'productPage.wfcServices.topFeature.title',
    subheader: 'productPage.wfcServices.topFeature.subheader',
    image: '/s2/raster/bike-repair-woman-workshop.png',
    alt: 'productPage.wfcServices.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.wfcServices.howItWorks.title',
    items: [
      {
        title: 'productPage.wfcServices.howItWorks.step1',
        description: 'productPage.wfcServices.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.wfcServices.howItWorks.step2',
        description: 'productPage.wfcServices.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.wfcServices.howItWorks.step3',
        description: 'productPage.wfcServices.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/report-filing-success-calendar.png',
    alt: 'productPage.wfcServices.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  whatsIncluded: {
    title: 'productPage.wfcServices.whatsIncluded.title',
    items: [
      {
        title: 'productPage.wfcServices.whatsIncluded.item1',
        description: 'productPage.wfcServices.whatsIncluded.item1ShortDescription'
      },
      {
        title: 'productPage.wfcServices.whatsIncluded.item2',
        description: 'productPage.wfcServices.whatsIncluded.item2ShortDescription'
      },
      {
        title: 'productPage.wfcServices.whatsIncluded.item3',
        description: 'productPage.wfcServices.whatsIncluded.item3ShortDescription'
      },
      {
        title: 'productPage.wfcServices.whatsIncluded.item4',
        description: 'productPage.wfcServices.whatsIncluded.item4ShortDescription'
      },
      {
        title: 'productPage.wfcServices.whatsIncluded.item5',
        description: 'productPage.wfcServices.whatsIncluded.item5ShortDescription'
      },
      {
        title: 'productPage.wfcServices.whatsIncluded.item6',
        description: 'productPage.wfcServices.whatsIncluded.item6ShortDescription'
      },
      {
        title: 'productPage.wfcServices.whatsIncluded.item7',
        description: 'productPage.wfcServices.whatsIncluded.item7ShortDescription'
      }
    ],
    image: '/s2/raster/cafe-owner-using-tablet.png',
    alt: 'productPage.wfcServices.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false
  },
  faqs: {
    title: 'productPage.wfcServices.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.wfcServices.frequentlyAskedQuestions.faq1',
        answer: 'productPage.wfcServices.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.wfcServices.frequentlyAskedQuestions.faq2',
        answer: 'productPage.wfcServices.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.wfcServices.frequentlyAskedQuestions.faq3',
        answer: 'productPage.wfcServices.frequentlyAskedQuestions.faqAnswer3'
      }
    ]
  },
  assistance: {
    title: 'productPage.wfcServices.needAssistance.title',
    getInTouch: 'productPage.wfcServices.needAssistance.getInTouch',
    actions: 'productPage.wfcServices.needAssistance.actions'
  },
  getBuyButtonConfig: getWfcServicesBuyButtonConfig
};
